<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100" v-if="isLoaded">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" @Refresh="refresh" :scrId="scrId"></table-view>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesCal/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import SearchView from './Search/Search';
import TableView from './Table/Table';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false
		};
	},
	async mounted() {
		//MMCAD : 측정기 관리자, MMCCP : 측정기 협력업체, OS : 시스템 관리자
		this.setState_({ key: 'isMmcAdmin', value: await this.inclManyUsrGrp_(['MMCAD', 'OS']) });
		this.setState_({ key: 'isMmcGuest', value: await this.inclManyUsrGrp_(['MMCCP', 'OS']) });
		this.isLoaded = true;
	},
	components: { SearchView, TableView },
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView?.searchList();
		}
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	}
};
</script>

<style></style>
